import { MODAL_TYPES } from '../../../common/constants'

export const getModalPayloads = (props) => {
    const { modalType, selectedTableRows, params, columns } = props
    const { DELETE_MODAL, EXPORT_DATA_MODAL } = MODAL_TYPES

    switch (modalType) {
        case DELETE_MODAL:
            return {
                modalType: DELETE_MODAL,
                modalProps: {
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    callbackId: 'delete-companies',
                    appModule: 'company',
                },
            }
        case EXPORT_DATA_MODAL:
            return {
                modalType: EXPORT_DATA_MODAL,
                modalProps: {
                    params,
                    tableColumns: columns,
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    appModule: 'company',
                },
            }
        default:
            return null
    }
}
